module.exports = __webpack_public_path__ + "img/team.02f631dd.jpg";